import React, { useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  capitalizeFirstLetter,
  formatFileSize,
  handleDateSetUp,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import TableLoader from "../../../../loader/TableLoader";
import { approvedCatelogue } from "../../../../../redux/action/catalogue";
import { Modal } from "react-materialize";
import { slideDown, slideUp } from "./childern/TableAnimation";
import RejectionReason from "./childern/RejectionReason";
import HistoryRecord from "./childern/HistoryRecord";

function SellerCatelogueTable({
  catalogueList,
  CatelogueLoading,
  auctionStatus,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [expandedRow, setExpandedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [approvedData, setApprovedData] = useState(null);
  const [openValue, setOpenValue] = useState("");
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });

  const openModal = (item) => {
    setIsModalOpen(true);
    setApprovedData(item);
  };

  const closeModal = () => setIsModalOpen(false);
  const getStatusClass = (status) => {
    switch (status) {
      case "notApproval":
        return "red-text";
      case "approval":
        return "green-text";
      default:
        return "orange-text";
    }
  };

  const toggleRow = (itemId, rowRef, value) => {
    if (expandedRow === itemId) {
      slideUp(rowRef.current, {
        onComplete: () => setExpandedRow(null),
      });
      setOpenValue("");
    } else {
      setExpandedRow(itemId);
      slideDown(rowRef.current);
      setOpenValue(value);
    }
  };


  if (CatelogueLoading) {
    return (
      <div className="valign-wrapper justify-center cover white">
        <TableLoader
          headerData={[
            "File Name",
            "File Size",
            "Downloads",
            "Views",
            "Accepted",
            "Status",
            "Action",
          ]}
        />
      </div>
    );
  }

  const renderTooltips = () => (
    <>
      <ReactTooltip
        id="tooltip-timeline"
        place="top"
        content={<p>Activity History</p>}
      />
      <ReactTooltip
        id="tooltip-downlaodList"
        place="top"
        content={<p>Downloaded List</p>}
      />
      <ReactTooltip
        id="tooltip-viewList"
        place="top"
        content={<p>View List</p>}
      />
      <ReactTooltip
        id="tooltip-acceptedList"
        place="top"
        content={<p>Accepted List</p>}
      />
    </>
  );

  return (
    <div className={`mt-1 ${!isTablet && "table-container-style"}`}>
      <table
        className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
          }`}
      >
        <thead>
          <tr>
            {[
              "File Name",
              "File Size",
              "Downloads",
              "Views",
              "Accepted",
              "Created at",
              "Catalogue Status",
              "Action",
            ].map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {catalogueList?.map((item) => (
            <RowTable
              key={item?._id}
              item={item}
              id={id}
              isTablet={isTablet}
              navigate={navigate}
              openModal={openModal}
              getStatusClass={getStatusClass}
              toggleRow={toggleRow}
              expandedRow={expandedRow}
              openValue={openValue}
              auctionStatus={auctionStatus}
            />
          ))}
        </tbody>
      </table>
      {catalogueList?.length === 0 && <NoItemsLeftInTable />}
      {renderTooltips()}
      <Modal
        actions={[]}
        open={isModalOpen}
        options={{ onCloseEnd: closeModal }}
        className="modelAccount"
        id="modalView-details"
      >
        <h4 className="normal-size">
          Confirm to Approve {approvedData?.fileName} Catelogue.
        </h4>
        <p>
          <strong>This action cannot be undone.</strong> Please confirm that you
          want to proceed.
        </p>
        <div className="flex justify-end gap-1 mt-1">
          <button
            className="green btn-small"
            onClick={() =>
              dispatch(
                approvedCatelogue(
                  id,
                  approvedData._id,
                  setApprovedData,
                  closeModal
                )
              )
            }
          >
            Yes
          </button>
          <button className="red btn-small modal-close" onClick={closeModal}>
            No
          </button>
        </div>
      </Modal>
    </div>
  );
}

const RowTable = ({
  item,
  isTablet,
  navigate,
  openModal,
  toggleRow,
  expandedRow,
  openValue,
  auctionStatus,
}) => {
  const rowRef = useRef(null);

  return (
    <>
      <tr key={item?._id}>
        <td style={{ MaxWidth: !isTablet ? "240px" : "auto" }}>
          <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
            {item?.fileName}
          </span>
        </td>
        <td>{formatFileSize(item?.fileSize)}</td>
        <td>
          <span
            className="pointer"
            data-tooltip-id={"tooltip-downlaodList"}
          // onClick={() =>
          //   navigate(`/single-auction/${id}/${item._id}/downlaodBy`)
          // }
          >
            {item?.downloadedBy?.length}
          </span>
        </td>
        <td>
          <span
            className="pointer"
            data-tooltip-id={"tooltip-viewList"}
          // onClick={() => navigate(`/single-auction/${id}/${item._id}/viewBy`)}
          >
            {item?.viewedBy?.length || 0}
          </span>
        </td>
        <td>
          <span
            className="pointer"
            data-tooltip-id={"tooltip-acceptedList"}
          // onClick={() =>
          //   navigate(`/single-auction/${id}/${item._id}/acceptedBy`)
          // }
          >
            {item?.tradersConfirmed?.length || 0}
          </span>
        </td>
        <td>{handleDateSetUp(item?.createdAt)}</td>
        <td>
          <span
            className={
              item?.industryApproval?.status === "rejected"
                ? "red-text"
                : item?.industryApproval?.status === "approval"
                  ? "green-text"
                  : "orange-text"
            }
          >
            {item?.industryApproval?.status === "approval"
              ? capitalizeFirstLetter(item?.industryApproval?.status)
              : "Not Approved"}
          </span>
        </td>
        <td style={{ width: !auctionStatus && "350px" }}>
          <span className="flex justify-center gap-1">
            <button
              className="button-style pointer white-text cercle-purple"
              style={{ padding: "5px 15px" }}
              onClick={() => navigate(`/catalogue-view/${item?._id}`)}
            >
              View
            </button>
            {!auctionStatus && (
              <>
                {" "}
                <button
                  className="button-style pointer white-text green"
                  style={{ padding: "5px 15px", opacity: item?.industryApproval?.status === "approval" ? 0.3 : 1 }}
                  disabled={item?.industryApproval?.status === "approval"}
                  onClick={() =>
                    openModal({ _id: item._id, fileName: item.fileName })
                  }
                >
                  Approve
                </button>
                <button
                  className="valign-wrapper pointer red-text"
                  style={{ opacity: item?.industryApproval?.status === "approval" ? 0.3 : 1 }}
                  disabled={item?.industryApproval?.status === "approval"}
                  onClick={() => {
                    toggleRow(item?._id, rowRef, "notApproval");
                  }}
                >
                  <p className="text-decoration-underLine">Not Approve</p>
                </button>
                <span
                  className="material-icons-outlined pointer cercle-purple-text"
                  data-tooltip-id="tooltip-timeline"
                  onClick={() => toggleRow(item?._id, rowRef, "historyRecord")}
                >
                  timeline
                </span>
              </>
            )}
          </span>
        </td>
      </tr>
      <tr
        ref={rowRef}
        style={{ display: expandedRow === item?._id ? "table-row" : "none" }}
      >
        <td colSpan={9}>
          {openValue === "notApproval" ? (
            <RejectionReason onRejectResponseId={item?._id} />
          ) : (
            openValue === "historyRecord" && (
              <HistoryRecord rejectCommands={[...item?.commands]?.reverse()} />
            )
          )}
        </td>
      </tr>
    </>
  );
};

export default SellerCatelogueTable;
